import { withProfiler } from '@sentry/react';
import { useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { validate as uuidValidate } from 'uuid';

import { Layout } from '@components/Layout';
import { Loading } from '@components/Loading';
import { POSITION_ID } from '@constants/queryParams';
import { partnerNumberRegEx } from '@constants/regEx';
import { useHostedAttribution } from '@providers/state/HostedAttributionProvider';

const ReferralUnwrapped = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const { setAttributionToken, setHostedId } = useHostedAttribution();

  useEffect(() => {
    const attributionToken = id || '';

    if (!attributionToken || !uuidValidate(attributionToken)) {
      navigate('/');
      return;
    }
    const hostedId = searchParams.get(POSITION_ID) ?? '';
    const hostedIdValid = partnerNumberRegEx.test(hostedId);

    setAttributionToken(attributionToken);

    if (hostedIdValid) {
      setHostedId(hostedId);
    }
    navigate('/');
  }, [id, navigate, setAttributionToken, setHostedId, searchParams]);

  return (
    <Layout>
      <Loading />
    </Layout>
  );
};

const Referral = withProfiler(ReferralUnwrapped);

export { Referral };
